import type {CustomCodePlacement} from '@tinct/core-api-models';

export const customCodePlacementLabels: Record<CustomCodePlacement, string> = {
  head_start: 'Start of <head>',
  head_end: 'End of <head>',
  body_start: 'Start of <body>',
  body_end: 'End of <body>',
};

export const customCodePlacements = Object.keys(
  customCodePlacementLabels,
) as CustomCodePlacement[];
